<template>
    <section class="tables landing-page">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">View Documents</h4>
                    </div>
                    <div class="card-body">
                        <div style="overflow: auto">
                            <CircleLoader v-if="isLoading" />
                            <table class="table">
                                <thead class=" table-dark">
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Description</th>
                                        <th scope="col">Module Name</th>
                                        <th scope="col">Week Name</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody v-for="Module in allDocument" :key="Module.ModuleNumber">
                                    <tr>
                                        <th class="text-center" colspan="5">
                                            <h4>Module {{ Module.ModuleNumber }} - {{ Module.ModuleName }}</h4>
                                        </th>
                                    </tr>
                                    <tr v-for="Document in Module.Documents" :key="Document.DocID">
                                        <th scope="row">{{ Document.DocName }}</th>
                                        <td>{{ Document.DocDescription }}</td>
                                        <td>{{ Document.ModuleName }}</td>
                                        <td>{{ Document.WeekName }}</td>
                                        <td><button @click="editRedirect(Document)" class="btn btn-sm btn-primary">Edit</button></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>

import Vue from "vue";
import API from "@/api";

export default {
    data() {
        return {
            isLoading:false,
            currentModuleId: null,
            allDocument: [],
        }
    },
    methods: {
        getAllArchiveDocuments() {
            // this.isLoading = true;
            API.getAllArchiveDocuments(res => {
                console.log(res.data);
                this.allDocument = res.data;
                console.log(this.allDocument)
                this.isLoading = false;
            },err => {
                console.log(err);
                this.isLoading = false;
            });
        },
        shouldShowHeading(id) {
            if (id === this.currentModuleId) {
                return false; // Hide the heading if the module ID is the same as the currentModuleId
            } else {
                this.changeCurrentId(id);
                return true; // Show the heading if the module ID is different from the currentModuleId
            }
        },
        editRedirect(data){
            this.$router.push({name:"edit_document",params:{id:data.document_id,document:data}});
        },
        changeCurrentId(id) {
            this.currentModuleId = id;
        },
    },
    mounted() {
        this.isLoading = true;
        this.getAllArchiveDocuments();
    },
    components: {}
}

</script>